import {FuseNavigationItem} from '@fuse/components/navigation';

// si definiscono qui gli array di navigazione, per livello di accesso di imsign
export const guestNavigation: FuseNavigationItem[] = [];

export const standardNavigation: FuseNavigationItem[] = [
    {
        id   : 'map',
        title   : 'Map',
        type    : 'basic',
        icon : 'heroicons_outline:map-pin',
        link : '/map'
    },
    {
        id   : 'my-company',
        title   : 'My Company',
        type    : 'basic',
        icon : 'heroicons_outline:building-office-2',
        link : '/companies/${USER.COMPANY_ID}'
    },
    {
        id   : 'companies',
        title   : 'Companies',
        type    : 'basic',
        icon : 'heroicons_outline:building-office-2',
        link : '/companies',
        clearance: 'company_manager'
    },
    {
        id   : 'locations',
        title   : 'Locations',
        type    : 'basic',
        icon : 'heroicons_outline:map-pin',
        link : '/locations'
    },
    {
        id   : 'motorized-pulleys',
        title   : 'Motorized Pulleys',
        type    : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : '/motorized-pulleys'
    },
];

